export default __webpack_public_path__ + "static/media/italic.d9d8c523.svg";